import React, { Fragment, useEffect, useState, useRef } from "react";
import { Breadcrumbs } from "../../AbstractElements";
import { Container, Row } from "reactstrap";
import axios from "axios";
import { APPOINTMENTS_API } from "../../api";
import AppointmentsForm from "./AppointmentsForm";
import AppointmentsTable from "./AppointmentsTable";
import TableSkeleton from "../Common/Component/TableSkeleton";

const Appointments = () => {
  const [appointments, setAppointments] = useState([]);
  const [showAddAppointment, setShowAddAppointment] = useState(false);
  const [searchDate, setSearchDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const hasFetched = useRef(false);

  const handleSearch = (date) => {
    setSearchDate(date);
    fetchAppointments(date);
  };

  const fetchAppointments = async (date) => {
    setIsLoading(true);
    // Get userDetails and roleid from localStorage
    let userDetails = {};
    try {
      userDetails = JSON.parse(localStorage.getItem('userDetails')) || {};
    } catch (e) {
      userDetails = {};
    }
    const roleid = Number(userDetails.roleID);
    const allowedRoles = [1, 2, 3];
    let url = APPOINTMENTS_API;
    let params = [];
    if (date) {
      params.push(`date=${date}`);
    }
    if (!allowedRoles.includes(roleid)) {
      if (userDetails.email) {
        params.push(`patientContact.email=${encodeURIComponent(userDetails.email)}`);
      } else if (userDetails.mobile) {
        params.push(`patientContact.mobile=${encodeURIComponent(userDetails.mobile)}`);
      }
    }
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    try {
      const response = await axios.get(url);
      if (response.data.appointments) {
        setAppointments(response.data.appointments);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(true);
      console.error("Error fetching appointments:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    fetchAppointments();
  }, []);
  
  return (
    <Fragment>
      {!showAddAppointment ? (
        <>
          <Breadcrumbs
            mainTitle={"Appointments"}
            buttonTitle={"Add Appointment"}
            onClick={() => setShowAddAppointment(true)}
            searchDate={searchDate}
            setSearchDate={handleSearch}
            showDate={true}
          />

          <Container fluid={true}>
            <Row className="widget-grid">
              {isLoading ? (
                <TableSkeleton columns={6} rows={5} />
              ) : (
                <AppointmentsTable appointments={appointments} />
              )}
            </Row>
          </Container>
        </>
      ) : (
        <AppointmentsForm
          onClose={() => setShowAddAppointment(false)}
          onAppointmentAdded={(newAppointment) => {
            setAppointments((prev) => [...prev, newAppointment]);
            setShowAddAppointment(false);
          }}
        />
      )}
    </Fragment>
  );
};

export default Appointments;
